module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/icon_photo_experience-f44a9eb1f43c2decf3965ad80d941241.png";